/* eslint-disable */
import { getPageFromData } from '~/data/page';

async function fetchPath(path) {
  return new Promise(async (resolve, reject) => {
    const url = `/api/by-path/${path.replace(/^\/*/, '')}`;
    const { data, error } = await useAsyncData(`fetch_by-path_${path}`, () => $fetch(url));

    watch(data, value => {
      if (value) {
        resolve({ data: value, url });
      }
    }, { immediate: true });

    watch(error, value => {
      if (value) {
        reject({ error: value, url });
      }
    }, { immediate: true });
  })
}

export default async function (path) {
  const nuxtApp = useNuxtApp()

  let response;
  try {
    response = await fetchPath(path);
  } catch (err) {
    response = err;
  }

  const { data, error, url } = response;
  if (!data) { return { url, error }; }

  const page = getPageFromData(data.data);
  try {
    await nuxtApp.runWithContext(() => useSEO(page.seo))
  } catch (err) {
    console.error('ERROR useSEO', err);
  }

  return { url, page, data, error };
}